// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".property-label[data-v-10f6a56e]{color:grey;font-weight:700}.auth-section[data-v-10f6a56e]{background-color:silver;border:1px solid;border-radius:5px;font-weight:700;font-size:medium}.delivery-date-label[data-v-10f6a56e]{margin-top:7px}.continue-area[data-v-10f6a56e]{display:flex;justify-content:center;align-items:center;min-height:40px}.loading[data-v-10f6a56e]{opacity:.667}", ""]);
// Exports
module.exports = exports;
